import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";
import { Swipeable } from "react-swipeable";

import { theme } from "../../../utils/global-styles/theme";

import Bubble from "../../BubbleSlider/child-components/Bubble";

const TestimonialSlider = ({
  testimonials,
  hasGrayBackground,
  hasPrimaryBackground,
}) => {
  const [activeBubbleIndex, setActiveBubbleIndex] = useState(0),
    manuallyChangeSlide = index => {
      if (index < 0) {
        setActiveBubbleIndex(testimonials.length - 1);
      } else if (index >= testimonials.length) {
        setActiveBubbleIndex(0);
      } else {
        setActiveBubbleIndex(index);
      }
    },
    buildBubbles = (totalCount, activeIndex, setActive) => {
      const bubbles = [];
      for (let i = 0; i < totalCount; i++) {
        bubbles.push(
          <Bubble
            active={activeIndex === i}
            setActive={setActive}
            index={i}
            key={i}
            fillColor={hasPrimaryBackground ? "white-fill" : "primary-fill"}
            strokeColor={
              hasPrimaryBackground ? "white-stroke" : "primary-stroke"
            }
          />
        );
      }
      return bubbles;
    };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setActiveBubbleIndex((activeBubbleIndex + 1) % testimonials.length);
    }, 8000);
    return () => clearTimeout(timerId);
  }, [activeBubbleIndex, testimonials.length]);

  const SliderGrid = styled.div`
      display: flex;
      flex-direction: column;
      background-color: ${theme.colors.secondary};
      color: ${theme.colors.black};
      height: max-content;
      font-family: ${theme.fontFaces.headers};

      .fadein {
        -webkit-animation: fadein 2s ease-in-out; /* Safari, Chrome and Opera > 12.1 */
        -moz-animation: fadein 2s ease-in-out; /* Firefox < 16 */
        -ms-animation: fadein 2s ease-in-out; /* Internet Explorer */
        -o-animation: fadein 2s ease-in-out; /* Opera < 12.1 */
        animation: fadein 2s ease-in-out;

        @keyframes fadein {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @-moz-keyframes fadein {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @-webkit-keyframes fadein {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @-ms-keyframes fadein {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @-o-keyframes fadein {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      }
    `,
    QuoteContainer = styled.div`
      padding: 50px 0;
      height: max-content;
      max-height: 1000px;

      transition-property: all;
      transition-duration: 5s;
      transition-timing-function: ease;
    `,
    OpeningQuotationsContainer = styled.div`
      padding-top: 50px;
      display: flex;
      justify-content: flex-end;
    `,
    QuoteText = styled.h2`
      font-size: 20px;
      font-weight: bold;
      letter-spacing: -0.52px;
      line-height: 24px;
      padding-left: 1em;
      padding-right: 1em;

      @media only screen and (min-width: ${theme.breakpoints
          .tabletUp}) and (max-width: ${theme.breakpoints.iPadPro}) {
        padding-left: 40px;
        padding-right: 40px;
        font-size: 40px;
        font-weight: bold;
        letter-spacing: -1.04px;
        line-height: 48px;
      }

      @media only screen and (min-width: ${theme.breakpoints.iPadPro}) {
        padding-left: 342px;
        padding-right: 342px;
        font-size: 40px;
        font-weight: bold;
        letter-spacing: -1.04px;
        line-height: 48px;
      }
    `,
    AuthorInfoContainer = styled.div``,
    AuthorInfoText = styled.h3`
      font-size: 12px;
      font-weight: 500;
      line-height: 12px;
      padding-left: 1.5em;
      padding-right: 1em;
      margin-bottom: 40px;

      @media only screen and (min-width: ${theme.breakpoints.tabletUp}) and (max-width: ${theme.breakpoints.iPadPro}) {
        font-size: 24px;
        font-weight: bold;
        line-height: 30px;
        letter-spacing: -0.22px;
        padding-left: 40px;
        padding-right: 40px;
      }

      @media only screen and (min-width: ${theme.breakpoints.iPadPro}) {
        padding-left: 342px;
        padding-right: 342px;
        font-size: 24px;
        font-weight: 500;
        letter-spacing: -0.22px;
        line-height: 30px;
}
      }
    `,
    BubbleContainer = styled.div`
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 30px;
    `,
    QuoteTextClassName = hasPrimaryBackground ? "white" : "primary";

  return testimonials ? (
    <SliderGrid
      className=""
      onSwipedLeft={() => manuallyChangeSlide(activeBubbleIndex + 1)}
      onSwipedRight={() => manuallyChangeSlide(activeBubbleIndex - 1)}
    >
      <QuoteContainer className="fadein">
        <QuoteText>
          "
          {testimonials[
            activeBubbleIndex
          ].testimonialQuote.testimonialQuote.slice(1)}
        </QuoteText>
      </QuoteContainer>
      <AuthorInfoContainer className="fadein">
        <AuthorInfoText>
          {testimonials[activeBubbleIndex].authorName}
          {testimonials[activeBubbleIndex].authorTitle ? "," : ""}
        </AuthorInfoText>
        {testimonials[activeBubbleIndex].authorTitle && (
          <AuthorInfoText>
            {testimonials[activeBubbleIndex].authorTitle}
          </AuthorInfoText>
        )}
      </AuthorInfoContainer>
      <BubbleContainer>
        {buildBubbles(
          testimonials.length,
          activeBubbleIndex,
          manuallyChangeSlide
        )}
      </BubbleContainer>
    </SliderGrid>
  ) : null;
};

TestimonialSlider.propTypes = {
  testimonials: PropTypes.arrayOf(
    PropTypes.shape({
      authorName: PropTypes.string,
      authorTitle: PropTypes.string,
      testimonialQuote: PropTypes.shape({
        testimonialQuote: PropTypes.string,
      }),
    })
  ),
  hasGrayBackground: PropTypes.bool,
};

export default TestimonialSlider;
